module.exports = __webpack_public_path__ + "img/O.9cee60a8.jpg";